import { HelpButton } from "./HelpButton";
import { SearchBar } from "./SearchBar";

interface Props {
  /** Help page names to pass to HelpButton */
  help?: string[];
  /** Title for the search bar placeholder */
  title?: string;
  /** Whether to hide the search bar */
  hideSearchBar?: boolean;
  children?: React.ReactNode;
  /** Callback when a search is submitted */
  onSearch?: (search: string) => void;
}

export function ToolbarHeader({
  help,
  title = "",
  hideSearchBar = false,
  children,
  onSearch,
}: Props) {
  return (
    <div className="mb-xs flex items-center">
      <div className="flex grow items-center">
        <div className="flex w-full max-w-[2500px] items-center">
          {!hideSearchBar ? (
            <div className="mr-xs grow">
              <SearchBar onSearch={onSearch} title={title} />
            </div>
          ) : null}
          {help ? (
            <div>
              <HelpButton pageNames={help} />
            </div>
          ) : null}
        </div>
      </div>
      {children ? <div className="ml-3xl">{children}</div> : null}
    </div>
  );
}
